import React, { useState, useEffect } from 'react';
import InputField from "components/fields/InputField";
import { useAuth } from "context/AuthContext";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../../config/baseApi";

export default function SignIn() {
  const { login, user, loading } = useAuth();
  const navigate = useNavigate();
    const [username, setUsername] = useState("");
  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");
  useEffect(() => {
    if (!loading && user && user.isAuthenticated) {
      navigate("/admin/default");
    }
  }, [loading, user, navigate]);

  if (loading) {
    return (
      <div className="flex h-full w-full items-center justify-center">Loading...</div>
    );
  }


  const handleSignIn = async () => {
    try {
      // Call backend login endpoint
      const resp = await fetch(`${API_BASE_URL}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password1, password2 }),
      });

      // Read response as text first so we can handle non-JSON errors (HTML error pages, etc.)
      const text = await resp.text();
      let data = null;

      try {
        data = text ? JSON.parse(text) : null;
      } catch (err) {
        // If the server returned non-JSON, include the raw text in the error for debugging
        throw new Error(`Invalid JSON response from server: ${text}`);
      }

      if (!resp.ok) {
        // Prefer structured message from JSON if available, otherwise fall back to raw text
        const msg = data && (data.message || data.error) ? (data.message || data.error) : text;
        throw new Error(msg || "Login failed");
      }

      // data should include { token, user }
      login({ token: data.token, user: data.user });
      navigate("/admin/default");
    } catch (e) {
      // For now, simple alert; you can replace with better UI
      console.error("SignIn error:", e);
      alert(e.message || "Sign in failed");
    }
  };

  return (
    <div className="mt-16 mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
      {/* Sign in section */}
      <div className=" w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
        <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
          Sign In
        </h4>
        <p className="mb-9 ml-1 text-base text-gray-600">
          Enter your email and password to sign in!
        </p>
        {/* Email */}
        <InputField
          variant="auth"
          extra="mb-3"
          label="Email*"
          placeholder="mail@simmmple.com"
          id="username"
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />

        {/* Password */}
        <InputField
          variant="auth"
          extra="mb-3"
          label="Password*"
          placeholder="Min. 8 characters"
          id="password1"
          type="password"
          value={password1}
          onChange={(e) => setPassword1(e.target.value)}
        />

        <InputField
          variant="auth"
          extra="mb-3"
          label="Password*"
          placeholder="Min. 8 characters"
          id="password2"
          type="password"
          value={password2}
          onChange={(e) => setPassword2(e.target.value)}
        />

        <button onClick={handleSignIn} className="linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200">
          Sign In
        </button>
      </div>
    </div>
  );
}
